import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroupStyleDirective } from './form-group-style/form-group-style.directive';

@NgModule({
  declarations: [FormGroupStyleDirective],
  imports: [
    CommonModule
  ],
  exports: [FormGroupStyleDirective]
})
export class CommonDirectivesModule { }
